export default __webpack_public_path__ + "static/media/plan-beings.0b94dd62.png";